module.exports = {
	"title": "Chicago <i class=\"fa fa-arrow-right\"></i> Sydney <i class=\"fa fa-arrow-right\"></i> New Zealand",
	"start": "Chicago",
	"destinations": {
		"Chicago": {
			"lat": 41.786776,
			"lng": -87.752188
		},
		"San Francisco": {
			"lat": 37.621313,
			"lng": -122.378955
		},
		"Sydney": {
			"lat": -33.86882,
			"lng": 151.209296
		},
		"Christchurch": {
			"lat": -43.532054,
			"lng": 172.636225
		},
		"Lake Tekapo": {
			"lat": -44.004674,
			"lng": 170.477121
		},
		"Queenstown": {
			"lat": -45.031162,
			"lng": 168.662644
		},
		"Wanaka": {
			"lat": -44.703181,
			"lng": 169.132098
		},
		"Franz Josef": {
			"lat": -43.387329,
			"lng": 170.183288
		},
		"Auckland": {
			"lat": -36.84846,
			"lng": 174.763332
		},
		"Bay of Islands": {
			"lat": -35.18437,
			"lng": 174.164616
		},
		"Orewa": {
			"lat": -36.581552,
			"lng": 174.689952
		},
		"Waiwera": {
			"lat": -36.543368,
			"lng": 174.703911
		},
		"Honolulu": {
			"lat": 21.306944,
			"lng": -157.858333
		}
	},
	"items": [
		{
			"date": "February 11, 2017",
			"dayType": "<i class=\"fa fa-plane\"></i> Travel Day",
			"airports": [
				"MDW",
				"SFO"
			],
			"destinations": [
				"Chicago",
				"San Francisco"
			],
			"lodging": "Aloft San Francisco Airport",
			"activities": [
				"Golden Gate Bridge",
				"Sutro Baths"
			]
		},
		{
			"date": "February 12, 2017",
			"dayType": "<i class=\"fa fa-plane\"></i> Travel Day",
			"airports": [
				"SFO",
				"AKL",
				"SYD"
			],
			"destinations": [
				"San Francisco",
				"Auckland",
				"Sydney"
			],
			"lodging": "Air New Zealand",
			"activities": [
				"Golden Gate Park",
				"San Francisco Botanical Garden"
			]
		},
		{
			"date": "February 13, 2017",
			"dayType": "<i class=\"fa fa-plane\"></i> Travel Day",
			"airports": [
				"SFO",
				"AKL",
				"SYD"
			]
		},
		{
			"date": "February 14, 2017",
			"destinations": [
				"Sydney"
			],
			"lodging": "Sydney Hostel",
			"activities": [
				"Opera House",
				"Downtown Sydney"
			]
		},
		{
			"date": "February 15, 2017",
			"dayType": "<i class=\"fa fa-users\"></i> Group Tour",
			"destinations": [
				"Sydney"
			],
			"lodging": "Sydney Hostel",
			"activities": [
				"Blue Mountains Day Trip",
				"Katoomba Scenic World",
				"Jamison Valley/Three Sisters rock formations",
				"Echo Point",
				"Featherdale Wildlife Park",
				"Parramatta River cruise"
			]
		},
		{
			"date": "February 16, 2017",
			"dayType": "<i class=\"fa fa-users\"></i> Group Tour",
			"destinations": [
				"Sydney"
			],
			"lodging": "Sydney Hostel",
			"activities": [
				"Sydney City Tour",
				"Bondi Beach",
				"Sydney Harbour Luncheon Cruise"
			]
		},
		{
			"date": "February 17, 2017",
			"dayType": "<i class=\"fa fa-users\"></i> Travel Day",
			"airports": [
				"SYD",
				"CHC"
			],
			"destinations": [
				"Sydney",
				"Christchurch"
			],
			"lodging": "Haka Lodge Christchurch",
			"activities": [
				"Sydney Bridge Climb"
			]
		},
		{
			"date": "February 18, 2017",
			"dayType": "<i class=\"fa fa-bus\"></i> Haka Tours",
			"destinations": [
				"Christchurch",
				"Lake Tekapo"
			],
			"lodging": "Lake Tekapo Hotel",
			"activities": [
				"Downtown Christchurch",
				"Lake Tekapo"
			]
		},
		{
			"date": "February 19, 2017",
			"dayType": "<i class=\"fa fa-bus\"></i> Haka Tours",
			"destinations": [
				"Lake Tekapo",
				"Queenstown"
			],
			"lodging": "Haka Lodge Queenstown",
			"activities": [
				"Wine Tasting in Otago",
				"Salmon Farms",
				"Queenstown Gondola Ride"
			]
		},
		{
			"date": "February 20, 2017",
			"dayType": "<i class=\"fa fa-bus\"></i> Haka Tours",
			"destinations": [
				"Queenstown"
			],
			"lodging": "Haka Lodge Queenstown",
			"activities": [
				"Milford Sound Trip"
			]
		},
		{
			"date": "February 21, 2017",
			"dayType": "<i class=\"fa fa-bus\"></i> Haka Tours",
			"destinations": [
				"Queenstown",
				"Wanaka"
			],
			"lodging": "Wanaka Hotel",
			"activities": [
				"Arrowtown",
				"Cardrona - New Zealand's Oldest Pub",
				"Wanaka"
			]
		},
		{
			"date": "February 22, 2017",
			"dayType": "<i class=\"fa fa-bus\"></i> Haka Tours",
			"destinations": [
				"Wanaka",
				"Franz Josef"
			],
			"lodging": "Franz Josef Hotel",
			"activities": [
				"Mt. Iron Hike",
				"Random Road Trip Stops"
			]
		},
		{
			"date": "February 23, 2017",
			"dayType": "<i class=\"fa fa-bus\"></i> Haka Tours",
			"destinations": [
				"Franz Josef"
			],
			"lodging": "Franz Josef Hotel",
			"activities": [
				"Glacier Helicopter Hike",
				"Farewell Party"
			]
		},
		{
			"date": "February 24, 2017",
			"dayType": "<i class=\"fa fa-bus\"></i> Haka Tours",
			"destinations": [
				"Franz Josef",
				"Christchurch"
			],
			"lodging": "Haka Lodge Christchurch",
			"activities": [
				"Hokitika Greenstone Factory",
				"National Kiwi Centre (time permitting)",
				"Tranz Alpine Train Crossing"
			]
		},
		{
			"date": "February 25, 2017",
			"dayType": "<i class=\"fa fa-birthday-cake\"></i> Birthday",
			"destinations": [
				"Christchurch"
			],
			"lodging": "Christchurch Hotel",
			"activities": [
				"Downtown Christchurch",
				"Relax"
			]
		},
		{
			"date": "February 26, 2017",
			"dayType": "<i class=\"fa fa-plane\"></i> Travel Day",
			"airports": [
				"CHC",
				"AKL"
			],
			"destinations": [
				"Christchurch",
				"Auckland"
			],
			"lodging": "Haka Lodge Auckland",
			"activities": [
				"Downtown Auckland"
			]
		},
		{
			"date": "February 27, 2017",
			"dayType": "<i class=\"fa fa-users\"></i> Group Tour",
			"destinations": [
				"Auckland"
			],
			"lodging": "Haka Lodge Auckland",
			"activities": [
				"Hobbiton Road Trip"
			]
		},
		{
			"date": "February 28, 2017",
			"dayType": "<i class=\"fa fa-bus\"></i> Flying Kiwi Tours",
			"destinations": [
				"Auckland",
				"Bay of Islands"
			],
			"lodging": "Campsite",
			"activities": [
				"Beach stop",
				"Paihia",
				"Mangrove walk or bike to Thundering Falls"
			]
		},
		{
			"date": "March 1, 2017",
			"dayType": "<i class=\"fa fa-bus\"></i> Flying Kiwi Tours",
			"destinations": [
				"Bay of Islands"
			],
			"lodging": "Campsite",
			"activities": [
				"Swimming with Dolphins",
				"Sailing the Bay of Islands"
			]
		},
		{
			"date": "March 2, 2017",
			"dayType": "<i class=\"fa fa-bus\"></i> Flying Kiwi Tours",
			"destinations": [
				"Bay of Islands",
				"Orewa"
			],
			"lodging": "Campsite",
			"activities": [
				"Sand Boarding Opononi",
				"Hot Pools and Slides"
			]
		},
		{
			"date": "March 3, 2017",
			"dayType": "<i class=\"fa fa-bus\"></i> Flying Kiwi Tours",
			"destinations": [
				"Waiwera",
				"Auckland"
			],
			"lodging": "Haka Lodge Auckland",
			"activities": [
				"Downtown Auckland",
				"Relax"
			]
		},
		{
			"date": "March 4, 2017",
			"dayType": "<i class=\"fa fa-plane\"></i> Travel Day",
			"airports": [
				"AKL",
				"HNL",
				"SFO"
			],
			"destinations": [
				"Auckland",
				"Honolulu",
				"San Francisco"
			],
			"lodging": "Aloft San Francisco",
			"activities": [
				"Recovery"
			]
		},
		{
			"date": "March 5, 2017",
			"dayType": "<i class=\"fa fa-plane\"></i> Travel Day",
			"airports": [
				"SFO",
				"MDW"
			],
			"destinations": [
				"San Francisco",
				"Chicago"
			],
			"lodging": "Home",
			"activities": [
				"Recovery"
			]
		}
	]
};


/*****************
 ** WEBPACK FOOTER
 ** ./src/data/itinerary.json
 ** module id = 91
 ** module chunks = 1
 **/